import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const blue = '#0d4efe';
const ink = '#1a1a2e';
const muted = '#5a6478';

export const StyledLeadBreakdownDialog = styled(Dialog)(() => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(26, 26, 46, 0.52)',
    backdropFilter: 'blur(4px)',
  },
  '& .MuiDialog-paper': {
    borderRadius: 16,
    overflow: 'hidden',
    border: '1px solid rgba(13, 78, 254, 0.14)',
    boxShadow:
      '0 24px 56px rgba(13, 78, 254, 0.16), 0 8px 24px rgba(0, 0, 0, 0.06)',
    background: '#ffffff',
    maxWidth: 760,
    width: '100%',
  },
}));

export const LeadBreakdownTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.75),
  margin: 0,
  padding: theme.spacing(2.5, 3),
  paddingRight: theme.spacing(6),
  paddingBottom: theme.spacing(2),
  position: 'relative',
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.14) 0%, rgba(13, 78, 254, 0.1) 55%, rgba(13, 78, 254, 0.04) 100%)',
  borderBottom: '1px solid rgba(13, 78, 254, 0.1)',
  fontWeight: 700,
  fontSize: '1.125rem',
  lineHeight: 1.35,
  letterSpacing: '-0.02em',
  color: ink,
  '& .lead-breakdown-icon-wrap': {
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(145deg, rgba(1, 235, 178, 0.2) 0%, rgba(13, 78, 254, 0.15) 100%)',
    border: '1px solid rgba(13, 78, 254, 0.18)',
    boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.6)',
  },
  '& .lead-breakdown-icon': {
    fontSize: 26,
    color: blue,
  },
}));

export const LeadBreakdownCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: muted,
  borderRadius: 10,
  '&:hover': {
    background: 'rgba(13, 78, 254, 0.08)',
    color: ink,
  },
}));

export const LeadBreakdownContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2, 3, 2.5),
  '&.MuiDialogContent-root': {
    paddingTop: theme.spacing(2),
  },
  color: muted,
}));

export const LeadBreakdownIntro = styled(Typography)(() => ({
  color: muted,
  marginBottom: 16,
}));

export const LeadTypeGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
  gap: 12,
  margin: '0 0 16px',
}));

export const LeadTypeStat = styled(Box)(() => ({
  padding: '12px 14px',
  borderRadius: 12,
  background: '#f7fafc',
  border: '1px solid rgba(13, 78, 254, 0.08)',
}));

export const LeadTypeValue = styled(Typography)(() => ({
  fontFamily: "'Exo 2', sans-serif",
  fontWeight: 700,
  fontSize: '1.45rem',
  lineHeight: 1.1,
  color: ink,
}));

export const LeadTypeLabel = styled(Typography)(() => ({
  color: muted,
  fontWeight: 600,
  fontSize: '0.85rem',
}));

export const LeadTableWrap = styled(Box)(() => ({
  width: '100%',
  overflowX: 'auto',
}));

export const LeadTable = styled('table')(() => ({
  width: '100%',
  borderCollapse: 'collapse',
  '& th': {
    textAlign: 'left',
    color: muted,
    fontWeight: 700,
    fontSize: '0.78rem',
    padding: '8px 10px',
    borderBottom: '1px solid rgba(13, 78, 254, 0.12)',
    whiteSpace: 'nowrap',
  },
  '& td': {
    padding: '10px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    color: ink,
    fontSize: '0.9rem',
  },
  '& th.num, & td.num': {
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
}));

export const LeadBreakdownEmpty = styled(Typography)(() => ({
  color: muted,
  padding: '8px 0',
}));

export const LeadBreakdownActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(1.5, 3, 2.25),
  justifyContent: 'flex-end',
  background: 'linear-gradient(180deg, rgba(247, 250, 252, 0.9) 0%, #f7fafc 100%)',
  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
}));

export const LeadBreakdownCloseAction = styled(Button)(() => ({
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: 10,
  padding: '10px 20px',
  color: ink,
  borderColor: 'rgba(13, 78, 254, 0.28)',
  backgroundColor: '#fff',
  '&:hover': {
    borderColor: blue,
    backgroundColor: 'rgba(13, 78, 254, 0.06)',
  },
}));
